<template>
  <div class="wrapper">
    <el-dialog
      title="转账支付"
      :visible.sync="dialogVisible"
      width="600px"
      append-to-body
      :before-close="close"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="付款总额">
          <el-input v-model="userDdata.deliveryFeeDeserved" disabled />
        </el-form-item>
        <el-form-item label="托运人已付金额">
          <el-input v-model="userDdata.allotTaxAmount" disabled />
        </el-form-item>
        <el-form-item label="已预付油点">
          <el-input v-model="userDdata.payOil" disabled />
        </el-form-item>
        <el-form-item label="已预付金额">
          <el-input v-model="userDdata.payAmount" disabled />
        </el-form-item>
        <el-form-item label="打款金额" prop="amount">
          <el-input
            v-model="formData.amount"
            @input="
              value =>
                formFormatter.isFloor2(value, oldValue, formData, 'amount')
            "
          />
        </el-form-item>
        <el-form-item label="平台付款银行">
          <el-input v-model="formData.platformBank" disabled />
        </el-form-item>
        <el-form-item label="平台开户企业">
          <el-input v-model="formData.platformCompanyName" disabled />
        </el-form-item>
        <el-form-item label="平台公户账号">
          <el-input v-model="formData.platformAccount" disabled />
        </el-form-item>
        <el-form-item label="收款方银行">
          <el-input v-model="backData.bankName" disabled />
        </el-form-item>
        <el-form-item label="收款方名称">
          <el-input v-model="backData.name" disabled />
        </el-form-item>
        <el-form-item label="收款方账号">
          <el-input v-model="backData.account" disabled />
        </el-form-item>
        <el-form-item label="付款时间" prop="payTime">
          <el-date-picker
            v-model="formData.payTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item label="流水号" prop="orderNo">
          <el-input
            v-model="formData.orderNo"
            @change="
              value => {
                formData.orderNo = value.replace(/\W/g, '');
              }
            "
          />
        </el-form-item>
        <el-form-item label="支付凭证" required>
          <ImgUpload
            :upload-config="{
              lebal: '支付凭证',
              prefix: 'payReceipt',
              form: formData,
              suffix: 'Img'
            }"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">
            确认打款
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  bankPartyCode,
  cashAdvanceBank,
  loginUserDefaultHousehold
} from "@/api/transport";
import ImgUpload from "@/components/ImgUpload";
import request from "@/utils/request";
export default {
  components: {
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      formData: {
        codes: [],
        orderNo: "",
        payeeCode: "",
        payReceiptImg: ""
      },
      userDdata: {},
      backData: {},
      rules: {
        amount: [
          { required: true, message: "请输入打款金额", trigger: "blur" }
        ],
        orderNo: [
          { required: true, message: "请输入流水号", trigger: "change" },
          { max: 64, message: "长度不能超过64个字符" }
        ],
        payTime: [{ required: true, message: "请选择时间", trigger: "blur" }]
      },
      rLoading: ""
    };
  },
  created() {},
  methods: {
    show(data) {
      this.userDdata = data;
      this.formData = Object.assign({}, this.parentData);
      this.findList();
    },
    // 获取/查询 列表
    async findList() {
      const rLoading = this.openLoading();
      let response_l = await loginUserDefaultHousehold({
        branchCode: this.parentData.branchCode,
        type: 1
      });
      if (!response_l.data) {
        this.$message.error("当前机构没有默认公户无法打款");
        return;
      }
      // let response = await bankPartyCode(this.parentData.createdBy)
      let bankParams = {
        partyCode: this.parentData.payeeCode,
        orderDetailCodes: this.parentData.orderDetailCode
      };
      let response = await bankPartyCode(bankParams);
      rLoading.close();
      if (!response.data) {
        this.$message.error("当前实际承运人没有绑定银行卡无法打款！");
        return;
      }
      this.dialogVisible = true;
      this.backData = response.data;
      this.formData.platformBank = response_l.data.bankName;
      this.formData.platformCompanyName = response_l.data.companyName;
      this.formData.platformAccount = response_l.data.bankNum;
      this.formData.payeePhone = this.backData.phone;
    },
    // 提交
    submit() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          this.rLoading = this.openLoading();
          this.verifyPayee(this.formData, async _ => {
            let response = await cashAdvanceBank(this.formData);
            this.rLoading.close();
            this.$message.success(response.msg);
            this.$emit("onSuccess");
            this.dialogVisible = false;
          });
        }
      });
    },
    verifyPayee(params, backFun) {
      request({
        url: `/ntocc-tms-api/payAdvance/verifyPayee`,
        method: "get",
        params: params
      }).then(response => {
        if (response.data) {
          backFun();
        } else {
          this.$confirm("预付将使本账户汇款超额，是否继续预付操作？")
            .then(_ => {
              backFun();
            })
            .catch(_ => {
              this.rLoading.close();
            });
        }
      });
    },
    // cancel(){
    //   this.$emit('onCancel')
    //   this.dialogVisible = false
    // },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.formData.pageNum = currentPage;
      this.formData.pageSize = pageSize;
      this.findList();
    },
    // 关闭
    close() {
      this.$refs.formData.resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
